var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mp-box',[_c('mp-button',{attrs:{"variant":_vm.variant},on:{"click":_vm.onClickCreate}},[_vm._v(_vm._s(_vm.title))]),_c('modal-warn-quota',{attrs:{"title":_vm.title,"is-restricted":"","is-open":_vm.isModalExceed},on:{"update:isOpen":function($event){_vm.isModalExceed=$event},"update:is-open":function($event){_vm.isModalExceed=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }